import { createRouter, createWebHistory } from 'vue-router'
import routes from "./routes";

// configure router
const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active'
})

export default router;
